import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class AttributeRequirementsString
*  Настройки строкового атрибута
*/
export class AttributeRequirementsString extends ActiveModel {

  /**
  * type
  *   */
  @ActiveField({ readonly: true, value: () => 'String' })
  readonly type: string = 'String'


  /**
  * minLength
  * Минимальная разрешённая длина строки  */
  @ActiveField()
  minLength?: null | number


  /**
  * maxLength
  * Максимальная разрешённая длина строки  */
  @ActiveField()
  maxLength?: null | number


  /**
  * multiline
  * Допустимы ли переносы строк  */
  @ActiveField()
  multiline?: boolean
}
